module.exports = __webpack_public_path__ + "img/norbotics-favicon.ee16cd79.png";